module.exports = __webpack_public_path__ + "img/logo.457f75f2.png";